<template>
  <div class="bg-dark text-white header sticky-top">
    <div class="container vap-section d-flex justify-content-between py-3">
      <NuxtLink to="/"
        ><div>
          <svg
            viewBox="0 0 260 120"
            width="160"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use fill="white" href="../assets/svg/vap-logo.svg#logo" />
          </svg></div
      ></NuxtLink>

      <div class="d-flex justify-content-between align-items-center">
        <div class="space">
          <NuxtLink to="/podcast"
            ><span
              :class="{ 'menu-active': podcastActive }"
              class="fw-bold fs-5"
              >Podcast</span
            ></NuxtLink
          >
        </div>
        <div class="space">
          <NuxtLink to="/hoerbuch">
            <span
              :class="{ 'menu-active': hoerbuchActive }"
              class="fw-bold fs-5"
              >Hörbuch & Hörspiel</span
            ></NuxtLink
          >
        </div>

        <div class="space">
          <NuxtLink to="/story">
            <span :class="{ 'menu-active': storyActive }" class="fw-bold fs-5"
              >Unsere Story</span
            ></NuxtLink
          >
        </div>
        <!-- <div class="space fw-bold fs-5" style="color: grey">
          <span class="fw-bold">EN</span>
          <span> / </span>
          <span>DE</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
const router = useRouter();
const currentRoute = router.currentRoute.value.path;

const podcastActive = computed(() => {
  return currentRoute == "/podcast" ? true : false;
});

const hoerbuchActive = computed(() => {
  return currentRoute == "/hoerbuch" ? true : false;
});

const storyActive = computed(() => {
  return currentRoute == "/story" ? true : false;
});
</script>

<style lang="scss" scoped>
.space {
  margin-left: 1vw;
  margin-right: 1vw;
}

.active-menu {
  border-bottom: 2px solid black;
  padding: 6px 6px;
}

.header {
  border-bottom: 1px solid rgb(57, 57, 57);
}

a {
  color: white;
}

a:hover {
  color: #fc4667;
}

.menu-active {
  color: white !important;
  padding-bottom: 4px;
  border-bottom: 2px solid #ffffff;
}
</style>
